(function ($) {
    $(function () {
        // Initialize WOW.js plugin
    });
  function hidingBlogPost () {
    $(".exclude-from-landing-page").remove();
    var email_wrap = $(".blog-post-landing .email-box");
    var offset = email_wrap.offset();
    if (offset.left <= 698 ) {
    var card_wrap = ".blog-post-landing .card-outer",
      cloned = $(card_wrap).eq(1).clone();
      $(card_wrap).eq(1).addClass("old");
      $("body .blog-post-landing .row:first-child").prepend(cloned);
      $(card_wrap+".old").remove();
    }
  }
    $(window).on("load",function () {
      if ($(".blog-post-landing").length > 0) {
        setTimeout(hidingBlogPost, 700);
      }
    });
    $(window).on('load', function () {
        new WOW().init();
        if ($('body').hasClass('page-id-124')) {
            $('.generic-reference-slider').addClass('carrers-refrence');
        }
        if ($('body').hasClass('page-id-63')) {
            document.title = 'Blach Construction';
        }

        $('body .blog-landing .filter-nav .filter-inner').each(function () {
            var width = $(this).width();
            $('body .blog-landing .filter-nav .filter-inner.sort-div > ul > li > ul').css('width', width + 'px');
        });

        if($('html').hasClass("ua-ie")){
            $("body").addClass("ie-all");
        }
        if($('html').hasClass("ua-ie")){
            $('.bg-img').imageResponsiveIe();
        }
        if($('html').hasClass("ua-ie")){
            $('.overview .img-outer').imageResponsiveIe();
        }
        if($('html').hasClass("ua-mobile-iphone")){
            $("body").addClass("ua-mobile-iphone");
        }
        if($('html').hasClass("ua-mobile")){
            $("body").addClass("ua-mobile");
        }
    });
    $.fn.imageResponsiveIe = function () {
        return this.each(function () {
            if(!$(this).parents('section').hasClass("news-ref-slider")){
                var imgUrl = $(this).find("img").prop("src");
                if (imgUrl) {
                    $(this).find("img").attr("style", "opacity: 0");
                    $(this).css("backgroundImage", 'url(' + imgUrl + ')').css({'background-repeat': 'no-repeat', 'background-position': 'center', 'background-size': 'cover'});
                }
            }
            if($(this).hasClass("no-banner-image")){
                $(this).find("img").removeAttr('style');
            }
        });
    };
    $(window).on('resize', function () {
        $('body .blog-landing .filter-nav .filter-inner').each(function () {
            var width = $(this).width();
            $('body .blog-landing .filter-nav .filter-inner.sort-div > ul > li > ul').css('width', width + 'px');

        });
    });
    var $div_offset;
    $(window).on('load scroll ', function (e) {
        e.stopPropagation();
        $('.parallax-move-left').each(function () {
            if ($('.parallax-move-left').length > 0) {
                $div_offset = $(this).offset().top;
            }
            var scrollTop = $(window).scrollTop();
            var $diff = ($div_offset - scrollTop) / 2 * 0.5;
            $(this).css({'background-position-y': $diff + 'px'});
        });

        $('.parallax-move-right').each(function () {
            if ($('.parallax-move-right').length > 0) {
                $div_offset = $(this).offset().top;
            }
            var scrollTop = $(window).scrollTop();
            var $diff = ($div_offset - scrollTop) / 2 * 0.5 + 300;
            $(this).css({'background-position-y': $diff + 'px'});
        })
    });

    function removeClass(){
        $('.expertise-tabs').removeClass('stop-div');
    }

})(jQuery);


// Force external links to open in new tab / window
(function($){
    $(function(){
        var siteName = window.location.host.replace('www.', '');
        $('a[href^="htt"]:not([target]):not([href*="www.' + siteName + '"]):not([href*="//' + siteName + '"]):not([class*="fancybox"])').attr('target', '_blank');
    });
})(jQuery);